import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { StyledInstagram } from '../../components/instagram-loader/InstagramLoader.styles';
import { DefaultLayout } from '../default/DefaultLayout';

export const StyledCollectionLayout = styled(DefaultLayout)`
  ${StyledInstagram} {
    padding: 10px 10px 0 10px;

    ${mediaQueryWidth({ min: 'mobile' })`
      padding: 50px 60px 0 60px;
    `}
  }
`;

export const StyledCollectionResultsLayout = styled.div`
  padding-top: rem(20);
  & > div {
    padding-top: 0 !important;
  }
`;
